module.exports = __webpack_public_path__ + "img/ufrj.efb75278.png";